module.exports = __webpack_public_path__ + "img/pay_suc.f8523be8.png";